var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadlockblack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0.25C5.83968 0.25 4.72688 0.710936 3.90641 1.53141C3.08594 2.35188 2.625 3.46468 2.625 4.625V7.125C1.96196 7.125 1.32607 7.38839 0.857233 7.85723C0.388392 8.32607 0.125 8.96196 0.125 9.625V15.25C0.125 15.913 0.388392 16.5489 0.857233 17.0178C1.32607 17.4866 1.96196 17.75 2.625 17.75H11.375C12.038 17.75 12.6739 17.4866 13.1428 17.0178C13.6116 16.5489 13.875 15.913 13.875 15.25V9.625C13.875 8.96196 13.6116 8.32607 13.1428 7.85723C12.6739 7.38839 12.038 7.125 11.375 7.125V4.625C11.375 2.20833 9.41667 0.25 7 0.25ZM10.125 7.125V4.625C10.125 3.7962 9.79576 3.00134 9.20971 2.41529C8.62366 1.82924 7.8288 1.5 7 1.5C6.1712 1.5 5.37634 1.82924 4.79029 2.41529C4.20424 3.00134 3.875 3.7962 3.875 4.625V7.125H10.125Z",
    fill: "#282828"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockblack);
export default __webpack_public_path__ + "static/media/padlockblack.d3e1dd33a30860338e3edfa014131846.svg";
export { ForwardRef as ReactComponent };